module.exports = __webpack_public_path__ + "static/img/personinfo_ad_banner1.4c30bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personinfo_ad_banner1.png
// module id = jWEA
// module chunks = 0